import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["addButtonText", "addButtonNoBorder", "maxCount", "Component", "config"];

/* eslint-disable no-plusplus */
import React from 'react';
import _ from 'lodash';
import { updateFormKey, rerangeFormKey } from '@/utils/tool';
import { getFormValue, setFormValue } from '@/store';
import ButtonAdd from '../ButtonAdd/index.js';
/* interface PropTypes {
  // item to add
  Component: React.Component;
  // config json
  config: {},
  initCount: number;
  maxCount: number;
  // formKey
  formValueArrayKey?: string;
  // triggered when add or delete item
  onCountChange(e: { type: 'add' | 'delete', count: number }): void;
  addButtonText: string;
  addButtonNoBorder: boolean;
} */

export default class AddableBlock extends React.Component {
  constructor(props) {
    super(props);

    this.handleAdd = () => {
      const {
        components
      } = this.state;
      const len = components.length;

      if (len < this.props.maxCount) {
        this.updateComponents([...components, this.getNewConfig(len)], 'add');
      }
    };

    this.handleDelete = index => {
      const {
        formValueArrayKey
      } = this.props;
      const {
        components
      } = this.state;
      components.splice(index, 1);
      components.forEach(rerangeFormKey);
      this.updateComponents(components, 'delete'); // 加个定制化的逻辑 专门删除被保人用

      const isInsure = ['trailElement[1]', 'insured', 'calcObj.insure'].indexOf(formValueArrayKey) !== -1;

      if (isInsure) {
        // 因为在提交时候会对这三个被保人做合并处理
        // 所以删除的时候也要都删除掉
        const insuredList = getFormValue('insured');
        const trailInsured = getFormValue('trailElement[1]');
        const calcInsured = getFormValue('calcObj.insure');

        if (insuredList) {
          insuredList.splice(index, 1);
        }

        if (trailInsured) {
          trailInsured.splice(index, 1);
        }

        if (calcInsured) {
          calcInsured.splice(index, 1);
        }

        setFormValue({
          insured: insuredList,
          'trailElement[1]': trailInsured,
          'calcObj.insure': calcInsured
        });
        return;
      } // update stored form value


      if (formValueArrayKey) {
        const arr = getFormValue(formValueArrayKey);

        if (arr) {
          arr.splice(index, 1);
        }

        setFormValue(formValueArrayKey, arr);
      }
    };

    this.state = this.getInitState();
  }

  componentDidUpdate(prevProps) {
    const {
      config,
      initCount
    } = this.props; // 响应模板配置改动 config !== prevProps.config ||

    if (initCount !== prevProps.initCount) {
      const initState = this.getInitState(); // eslint-disable-next-line react/no-did-update-set-state

      this.setState(initState);
    }
  }

  getInitState() {
    const {
      config,
      initCount
    } = this.props;
    this.configStr = JSON.stringify(config);

    const components = _.times(initCount > 0 ? initCount : 1, index => this.getNewConfig(index));

    return {
      components
    };
  }

  getNewConfig(index) {
    let newConfig = JSON.parse(this.configStr);
    const {
      noUpdateConfig
    } = this.props;

    if (index >= 0 && !noUpdateConfig) {
      newConfig = updateFormKey(newConfig, index);
    }

    newConfig.key = AddableBlock.childUniqueKeyCounter++;
    return newConfig;
  }

  updateComponents(components, type) {
    const {
      onCountChange
    } = this.props;
    this.setState({
      components
    });
    onCountChange && onCountChange({
      type,
      count: components.length
    });
  }

  render() {
    const _this$props = this.props,
          {
      addButtonText,
      addButtonNoBorder = true,
      maxCount,
      Component,
      config
    } = _this$props,
          rest = _objectWithoutProperties(_this$props, _excluded);

    const {
      components
    } = this.state;
    const total = components.length;
    console.log('components: ', components);
    return /*#__PURE__*/React.createElement("div", {
      className: "cc-addable-block"
    }, components.map((item, index) => /*#__PURE__*/React.createElement(Component // key={item.key} // 重复的key会导致元素不刷新, 不传key会导致内部元素的key重复 --不刷新
    , _extends({
      index: index,
      total: total,
      config: item,
      onDelete: this.handleDelete
    }, rest))), /*#__PURE__*/React.createElement(ButtonAdd, {
      visible: total < maxCount,
      noborder: addButtonNoBorder,
      onClick: this.handleAdd
    }, addButtonText));
  }

}
AddableBlock.childUniqueKeyCounter = 0;